// A list's WhatsApp code in the user's language, e.g. LISTA-0003 (PT) /
// LIST-0003 (EN): the list_prefix key. Same format as the API's
// listslist.FormatListCode; WhatsApp accepts either prefix.
export const formatListCode = (list, t) =>
  `${t('list_prefix')}-${String(list.lot_number).padStart(4, '0')}`;

// The code followed by the list's name, when it has one.
export const formatListTitle = (list, t) =>
  list.name ? `${formatListCode(list, t)} — ${list.name}` : formatListCode(list, t);
